import { useQuery, useQueryClient } from "@tanstack/react-query"

import { getNotificaciones } from "../services/notificaciones.service";
import { useEffect, useRef } from "react";

export const useNotificaciones = () => {

    const queryClient = useQueryClient();

    const previousSignatureRef = useRef('');

    const notificacionesQuery = useQuery({
        queryKey: ['notificaciones'],
        queryFn: () => getNotificaciones(),
        staleTime: 30_000, // 30 segundos
        refetchOnWindowFocus: true,
        refetchOnReconnect: true,
        refetchInterval: 60_000, // 60 segundos  
        refetchIntervalInBackground: true,
        placeholderData: {
            data: {}
        }
    });

    useEffect(() => {
      
        if (!notificacionesQuery.data) return;

        const { data } = notificacionesQuery.data;

        if (Object.values(data).length === 0) return;

        const notificaciones = Object.values(data).flat();

        //Crear referencia de fetch´s previos
        const signature = JSON.stringify(
            notificaciones
                .filter(
                    noti =>
                        noti.category === 'CITA' ||
                        noti.category === 'INMUNOTERAPIA'
                )
                .map(noti => ({
                    id: noti._id,
                    updatedAt: noti.updatedAt,
                    status: noti.status
                }))
        );

        // Si no cambió, salir
        if (signature === previousSignatureRef.current) return;

        // Guardar nueva firma
        previousSignatureRef.current = signature;

        // Invalidar queries
        queryClient.invalidateQueries({
            queryKey: ['agenda']
        });

        queryClient.invalidateQueries({
            queryKey: ['agendaInmunoterapia']
        });

    }, [notificacionesQuery.data, queryClient]);
    

    return {
        notificacionesQuery,
    }
}